import { useLocalStorage } from './useLocalStorage';
import type { ViewMode } from '../types';

const VIEW_MODE_KEY = 'bus-chibis-view-mode';

export function useViewMode() {
  const [viewMode, setViewMode] = useLocalStorage<ViewMode>(VIEW_MODE_KEY, 'grid');
  
  const isGrid = viewMode === 'grid';
  const isFeed = viewMode === 'feed';

  return {
    viewMode,
    setViewMode,
    isGrid,
    isFeed,
  };
}